import { useEffect, useState } from "react";
import Sidebar from "../../comman_page/Sidebar";
import { HeaderDashboard } from "../../comman_page/HeaderDashboard";
import { Container, Row, Col, Spinner, Button } from "react-bootstrap";
import { Footer } from "../../../../../public/containers/footer/Footer";
import { cronFailedTransactionAPI, cronTransactionListAPI, cronUpcomingTransactionAPI } from "../../../../../Studio-Services/Studio_Services";
import moment from "moment";
import { NewDateRange } from "../../../../../sharedComponents/NewDateRange";



export const CronTransaction = () => {
    const [loader, setLoader] = useState(false);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [dvalue, setDvalue] = useState();
    const [active, setActive] = useState('success');

    const [successList, setSuccessList] = useState([]);
    const [failedList, setFailedList] = useState([]);
    const [upcomingList, setUpcomingList] = useState([]);

    const successTransactions = async () => {
        const payload = { startDate, endDate };
        setLoader(true);
        try {
            const resp = await cronTransactionListAPI(payload);
            if (resp) {
                let data = resp.data;
                if (resp?.data?.length == 0) {
                    setSuccessList([]);
                    return;
                }
                setSuccessList(data);
                setLoader(false);
            }
        } catch (error) {
            console.log("---@Error------", error);
        } finally {
            setLoader(false);
        }
    }

    const failedTransactions = async () => {
        const payload = { startDate, endDate };
        setLoader(true);
        try {
            const resp = await cronFailedTransactionAPI(payload);
            if (resp) {
                let data = resp.data;
                if (resp?.data?.length == 0) {
                    setFailedList([]);
                    return;
                }
                setFailedList(data);
                setLoader(false);
            }
        } catch (error) {
            console.log("---@Error------", error);
        } finally {
            setLoader(false);
        }
    }


    const upcomingTransactions = async () => {
        const payload = { startDate, endDate };
        setLoader(true);
        try {
            const resp = await cronUpcomingTransactionAPI(payload);
            if (resp) {
                let data = resp.data;
                if (resp?.data?.length == 0) {
                    setUpcomingList([]);
                    return;
                }
                setUpcomingList(data);
                setLoader(false);
            }
        } catch (error) {
            console.log("---@Error------", error);
        } finally {
            setLoader(false);
        }
    }


    useEffect(() => {
        const start = moment().startOf("month").format("YYYY-MM-DD");
        const end = moment().endOf("month").format("YYYY-MM-DD");
        setStartDate(start);
        setEndDate(end);
    }, []);

    useEffect(() => {
        if (active === 'failed') {
            failedTransactions();
        } else if (active === 'upcoming') {
            upcomingTransactions();
        } else {
            successTransactions();
        }
    }, [startDate, endDate, active]);


    const successTotal = (successList || []).reduce((sum, item) => {
        return sum + parseFloat(item.amount || 0);
    }, 0);

    const failedTotal = (failedList || []).reduce((sum, item) => {
        return sum + parseFloat(item.amount || 0);
    }, 0);

    const upcomingTotal = (upcomingList || []).reduce((sum, item) => {
        return sum + parseFloat(item.amount || 0);
    }, 0);

    return (
        <>
            {loader && <div className='MainLoader'> <Spinner animation="border" role="status" className='Loader'> </Spinner> </div>}
            <div className="MainDashboard">
                <div className="MainLayout">
                    <Row>
                        <Sidebar />
                        <Col>
                            <div className="RightSide">
                                <HeaderDashboard />
                                <section className="addClient innerContent">
                                    <div className="AddClientContent">
                                        <Container>
                                            <h4 className="mb-4">Cron ( Recurring ) Transaction Report</h4>
                                            <Row>
                                                <Col md={4}>
                                                    <div className="mb-3 daterange_parent">
                                                        <NewDateRange
                                                            setDvalue={setDvalue}
                                                            dvalue={dvalue}
                                                            setStartDate={setStartDate}
                                                            setEndDate={setEndDate}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={8} className="mb-3" style={{ textAlign: 'right' }}>
                                                    <button
                                                        type="button"
                                                        className="btn btn-light mr-2 mb-2"
                                                        style={{
                                                            background: active === 'success' ? '#32C3F1' : '',
                                                            color: active === 'success' ? '#ffffff' : ''
                                                        }}
                                                        onClick={() => setActive('success')}
                                                    >
                                                        Success
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-light mr-2 mb-2"
                                                        style={{
                                                            background: active === 'failed' ? '#32C3F1' : '',
                                                            color: active === 'failed' ? '#ffffff' : ''
                                                        }}
                                                        onClick={() => setActive('failed')}
                                                    >
                                                        Failed
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="btn btn-light mb-2"
                                                        style={{
                                                            background: active === 'upcoming' ? '#32C3F1' : '',
                                                            color: active === 'upcoming' ? '#ffffff' : ''
                                                        }}
                                                        onClick={() => setActive('upcoming')}
                                                    >
                                                        Upcoming
                                                    </button>
                                                    <hr />
                                                </Col>
                                            </Row>

                                            {active === 'success' && (
                                                <>
                                                    <Row>
                                                        <Col className="mt-4" md={12}>
                                                            <table className="table table-striped">
                                                                <thead>
                                                                    <tr>
                                                                        <th>No</th>
                                                                        <th>Date</th>
                                                                        <th>Client Name</th>
                                                                        <th>Method</th>
                                                                        <th>Status</th>
                                                                        <th>Pass Name</th>
                                                                        <th>Amount </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {(successList || []).map((row, index) =>
                                                                        <tr key={index}>
                                                                            <td> {index + 1}</td>
                                                                            <td>{row.create_dt && moment.unix(row.create_dt).format('YYYY-MM-DD')}</td>
                                                                            <td> {row?.name + ' ' + row?.lastname}</td>
                                                                            <td> {row.payment_mode}</td>
                                                                            <td> {row.status}</td>
                                                                            <td> {row.pass_name}</td>
                                                                            <td>$ {row?.amount && parseFloat(row.amount).toFixed(2)}</td>
                                                                        </tr>)}
                                                                </tbody>
                                                                {successTotal &&
                                                                    <tfoot>
                                                                        <tr>
                                                                            <td colSpan="6" style={{ textAlign: 'right', fontWeight: 'bold' }}>
                                                                                Total
                                                                            </td>
                                                                            <td style={{ fontWeight: 'bold' }}>
                                                                                $ {successTotal && parseFloat(successTotal).toFixed(2)}
                                                                            </td>
                                                                        </tr>
                                                                    </tfoot>
                                                                }
                                                            </table>
                                                        </Col>
                                                    </Row>
                                                    {successList && (successList?.length || []) == 0 &&
                                                        <Row>
                                                            <Col md={12} style={{ display: 'flex', justifyContent: 'center', padding: '70px 0px' }}>
                                                                No Data Available
                                                            </Col>
                                                        </Row>
                                                    }
                                                </>
                                            )}
                                            {active === 'failed' && (
                                                <>
                                                    <Row>
                                                        <Col className="mt-4" md={12}>
                                                            <table className="table table-striped">
                                                                <thead>
                                                                    <tr>
                                                                        <th>No</th>
                                                                        <th>Date</th>
                                                                        <th>Client Name</th>
                                                                        <th>Method</th>
                                                                        <th>Status</th>
                                                                        <th>Pass Name</th>
                                                                        <th>Amount </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {(failedList || []).map((row, index) =>
                                                                        <tr key={index}>
                                                                            <td> {index + 1}</td>
                                                                            <td>{row.create_dt && moment.unix(row.create_dt).format('YYYY-MM-DD')}</td>
                                                                            <td> {row?.name + ' ' + row?.lastname}</td>
                                                                            <td> {row.pay_mode}</td>
                                                                            <td> {row.status}</td>
                                                                            <td> {row.pass_name}</td>
                                                                            <td>$ {row.amount && parseFloat(row.amount).toFixed(2)}</td>
                                                                        </tr>)}
                                                                </tbody>
                                                                {failedTotal &&
                                                                    <tfoot>
                                                                        <tr>
                                                                            <td colSpan="6" style={{ textAlign: 'right', fontWeight: 'bold' }}>
                                                                                Total
                                                                            </td>
                                                                            <td style={{ fontWeight: 'bold' }}>
                                                                                $ {failedTotal && parseFloat(failedTotal).toFixed(2)}
                                                                            </td>
                                                                        </tr>
                                                                    </tfoot>
                                                                }
                                                            </table>
                                                        </Col>
                                                    </Row>
                                                    {failedList && (failedList?.length || []) == 0 &&
                                                        <Row>
                                                            <Col md={12} style={{ display: 'flex', justifyContent: 'center', padding: '70px 0px' }}>
                                                                No Data Available
                                                            </Col>
                                                        </Row>
                                                    }
                                                </>
                                            )}

                                            {active === 'upcoming' && (
                                                <>
                                                    <Row>
                                                        <Col className="mt-4" md={12}>
                                                            <table className="table table-striped">
                                                                <thead>
                                                                    <tr>
                                                                        <th>No</th>
                                                                        <th>Date</th>
                                                                        <th>Client Name</th>
                                                                        <th>Method</th>
                                                                        <th>Status</th>
                                                                        <th>Pass Name</th>
                                                                        <th>Amount </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {(upcomingList || []).map((row, index) =>
                                                                        <tr key={index}>
                                                                            <td> {index + 1}</td>
                                                                            <td>{row.create_dt && moment.unix(row.create_dt).format('YYYY-MM-DD')}</td>
                                                                            <td> {row?.name + ' ' + row?.lastname}</td>
                                                                            <td> {row.payment_mode}</td>
                                                                            <td> {row.status}</td>
                                                                            <td> {row.pass_name}</td>
                                                                            <td>$ {row.amount && parseFloat(row.amount).toFixed(2)}</td>
                                                                        </tr>)}
                                                                </tbody>
                                                                {upcomingTotal &&
                                                                    <tfoot>
                                                                        <tr>
                                                                            <td colSpan="6" style={{ textAlign: 'right', fontWeight: 'bold' }}>
                                                                                Total
                                                                            </td>
                                                                            <td style={{ fontWeight: 'bold' }}>
                                                                                $ {upcomingTotal && parseFloat(upcomingTotal).toFixed(2)}
                                                                            </td>
                                                                        </tr>
                                                                    </tfoot>
                                                                }
                                                            </table>
                                                        </Col>
                                                    </Row>
                                                    {upcomingList && (upcomingList?.length || []) == 0 &&
                                                        <Row>
                                                            <Col md={12} style={{ display: 'flex', justifyContent: 'center', padding: '70px 0px' }}>
                                                                No Data Available
                                                            </Col>
                                                        </Row>
                                                    }
                                                </>
                                            )}
                                        </Container>
                                    </div>
                                </section>
                                <Footer />
                            </div>
                        </Col>
                    </Row >
                </div >
            </div >
        </>
    );
};
